import FormElementTypes from './../../model/FormElementTypes'
import DatetimeParser   from './../../model/parser/datetime-parser'

/**
 * @TODO: copy - paste - kvuli casove tistni -> potreba refaktorovat
 */
export default new class GridDataPreprocessor {

  /**
   *
   * @param row
   * @param columnsSpecification
   */
  preprocess (row, columnsSpecification) {
    this.preprocesDateTimeData(row, columnsSpecification)
    this.preprocesDecimalData(row, columnsSpecification)
    this.preprocesMoneyData(row, columnsSpecification)
  }

  /**
   *
   * @param rowData
   * @param columnsSpecification
   */
  preprocessData (rowData, columnsSpecification) {
    for (let i = 0; i < rowData.length; i++) {
      let row = rowData[i]

      this.preprocess(row, columnsSpecification)

      rowData[i] = row
    }

  }

  /**
   * @TODO: refaktorovat!!! nyni neni priorita
   * @private
   * @return []
   */
  getDateTimeColumns (columnsSpecification) {
    let dateColumns = []

    for (let i = 0; i < columnsSpecification.length; i++) {
      let column = columnsSpecification[i]

      if (column.FieldType === FormElementTypes.datepicker &&
        column.DataType === FormElementTypes.dataType.date) {
        dateColumns.push(column.Field)
      }
    }

    return dateColumns
  }

  /**
   * @TODO: refaktorovat!!! nyni neni priorita
   * @private
   * @return []
   */
  getDecimalColumns (columnsSpecification) {
    let dateColumns = []

    for (let i = 0; i < columnsSpecification.length; i++) {
      let column = columnsSpecification[i]

      if (column.DataType === FormElementTypes.dataType.decimal0
        || column.DataType === FormElementTypes.dataType.decimal1
        || column.DataType === FormElementTypes.dataType.decimal2
        || column.DataType === FormElementTypes.dataType.decimal3
        || column.DataType === FormElementTypes.dataType.decimal4
        || column.DataType === FormElementTypes.dataType.decimal99
      ) {
        dateColumns.push(column)
      }
    }

    return dateColumns
  }

  /**
   * @TODO: refaktorovat!!! nyni neni priorita
   * @private
   * @return []
   */
  getMoneyColumns (columnsSpecification) {
    let dateColumns = []

    for (let i = 0; i < columnsSpecification.length; i++) {
      let column = columnsSpecification[i]

      if (column.DataType === FormElementTypes.dataType.money) {
        dateColumns.push(column.Field)
      }
    }

    return dateColumns
  }

  /**
   *
   * @param itemData
   * @param columnsSpecification
   */
  preprocesDateTimeData (itemData, columnsSpecification) {
    let dateTimeColumns = this.getDateTimeColumns(columnsSpecification)

    for (let i = 0; i < dateTimeColumns.length; i++) {
      let dateTimeColumnName   = dateTimeColumns[i],
          parseEndDateRealDate = DatetimeParser.parseDate(
            itemData[dateTimeColumnName]),
          parseEndDateRealTime = DatetimeParser.parseTime(
            itemData[dateTimeColumnName])

      itemData[dateTimeColumnName] = parseEndDateRealDate + ' ' +
        parseEndDateRealTime
    }

    return itemData
  }

  /**
   *
   * @param itemData
   * @param columnsSpecification
   */
  preprocesDecimalData (itemData, columnsSpecification) {
    let decimalColumns = this.getDecimalColumns(columnsSpecification)

    for (let i = 0; i < decimalColumns.length; i++) {
      let dateTimeColumnName = decimalColumns[i]

      if (!itemData[dateTimeColumnName.field]) {
        continue
      }

      let dec = parseInt(dateTimeColumnName.dataType.slice(-1))

      itemData[dateTimeColumnName.field] = itemData[dateTimeColumnName.field].format(
        dec, 3, ' ', ',')
    }

    return itemData
  }

  /**
   *
   * @param itemData
   * @param columnsSpecification
   */
  preprocesMoneyData (itemData, columnsSpecification) {
    let moneyColumns = this.getMoneyColumns(columnsSpecification)

    for (let i = 0; i < moneyColumns.length; i++) {
      let dateTimeColumnName = moneyColumns[i]

      if (!itemData[dateTimeColumnName]) {
        continue
      }

      itemData[dateTimeColumnName] = itemData[dateTimeColumnName].format(
        2, 3, ' ', ',')
    }

    return itemData
  }

}
